import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import { KeyValue } from "@/main/models/common";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from "@/main/services/utils";
import { getInsurers, resetReducerInsurers, useInsurerReducer } from "@/main/store/insurer";
import { useDinamicFiltersMappingCodes } from "./dinamicFiltersMappingCodes";
import {
	getInsuranceSublines,
	resetReducerInsuranceSublines,
	useInsuranceSublineReducer,
} from "@/main/store/insuranceSubline";

export const INITIAL_FORM_STATE_INSURANCE_SUBLINE = {
	insuranceSubline: null as KeyValue | null,
	insurer: null as KeyValue | null,
};

export type IFormFiltersMappingTypeInsuranceSubline = typeof INITIAL_FORM_STATE_INSURANCE_SUBLINE;

interface IFiltersMappingTypeInsuranceSublineProps {}
function FiltersMappingTypeInsuranceSubline(_props: IFiltersMappingTypeInsuranceSublineProps) {
	const dispatch = useDispatch();
	const { watcherCountry, keyReducer, isRequiredField } = useDinamicFiltersMappingCodes();
	const { isolated: insurersReducer } = useInsurerReducer(keyReducer);
	const { isolated: insuranceSublineReducer } = useInsuranceSublineReducer(keyReducer);

	const { control, resetField, setValue } = useFormContext<IFormFiltersMappingTypeInsuranceSubline>();

	useEffect(() => {
		if (!isValueQueryParams(watcherCountry)) {
			resetField("insurer");
			resetField("insuranceSubline");
		}
		dispatch(getInsuranceSublines({}, keyReducer));
		if (isNullUndefined(watcherCountry)) return;

		dispatch(
			getInsurers(
				{
					guidCountry: String(watcherCountry.key),
					idStatusRegister: StatusRegisterEnum.Active,
				},
				keyReducer,
			),
		);

		return () => {
			dispatch(resetReducerInsurers());
			dispatch(resetReducerInsuranceSublines());
		};
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledInsurer = isNullUndefined(insurersReducer.data) || insurersReducer.data.length === 1;
	const disabledInsuranceSublineReducer =
		isNullUndefined(insuranceSublineReducer.data) || insuranceSublineReducer.data.length === 1;
	const orderedOptionsInsuranceSubline =
		insuranceSublineReducer.data?.sort((a, b) => a.value.localeCompare(b.value)) || [];

	return (
		<>
			<KogAutoCompleteControlled
				id="id-mappingCode-select-insurance-subline"
				nameCustom="insuranceSubline"
				label={getTranslateByKey("information.insuranceSubline")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={orderedOptionsInsuranceSubline}
				isLoading={insuranceSublineReducer.isLoading}
				disabled={disabledInsuranceSublineReducer}
				rulesCustom={{ required: isRequiredField("insuranceSubline") }}
				onChangeCustom={() => {}}
			/>
			<KogAutoCompleteControlled
				id="id-mappingCode-select-insurer"
				nameCustom="insurer"
				label={getTranslateByKey("information.insurer")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={insurersReducer.data}
				isLoading={insurersReducer.isLoading}
				disabled={disabledInsurer}
				rulesCustom={{ required: isRequiredField("insurer") }}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default FiltersMappingTypeInsuranceSubline;
